import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ScannerStatus, scannerStatusTranslation } from "../../../model";
import { NzPresetColor, NzStatusColor } from "ng-zorro-antd/core/color";

@Component({
  selector: 'app-scanner-controller',
  templateUrl: './scanner-controller.component.html',
  styleUrls: ['./scanner-controller.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ScannerControllerComponent {
  @Input()
  status: ScannerStatus | undefined;

  @Output()
  pause = new EventEmitter<void>();

  @Output()
  resume = new EventEmitter<void>();

  scannerStatusTranslation = scannerStatusTranslation



  ScannerStatus = ScannerStatus;

  public get statusColor(): string | NzStatusColor | NzPresetColor {
    //    console.log('ScannerControllerComponent.statusColor() called', { status: this.status });
    switch (this.status) {
      case ScannerStatus.Blocked:
      case ScannerStatus.Deciding:
      case ScannerStatus.Ejecting:
      case ScannerStatus.Failed:
        return "error";
      case ScannerStatus.Ready:
      case ScannerStatus.Scanning:
      case ScannerStatus.Inspecting:
      case ScannerStatus.Continuing:
        return "success";
      case ScannerStatus.Idle:
        return "warning";
      case ScannerStatus.Running:
      case ScannerStatus.Starting:
        return "processing";
      default:
        return "error";
    }
  }

  public get statusIcon(): string {
    switch (this.status) {
      case ScannerStatus.Idle:
        return "pause-circle";
      case ScannerStatus.Starting:
        return "clock-circle";
      case ScannerStatus.Ready:
        return "login";
      case ScannerStatus.Scanning:
        return "camera";
      case ScannerStatus.Inspecting:
        return "search";
      case ScannerStatus.Continuing:
        return "check-circle";
      case ScannerStatus.Deciding:
        return "warning";
      case ScannerStatus.Ejecting:
        return "logout";
      case ScannerStatus.Failed:
        return "close-circle";
      case ScannerStatus.Blocked:
      case ScannerStatus.Running:
      default:
        return "info-circle";
    }
  }

  public get action(): string {
    switch (this.status) {
      case ScannerStatus.Running:
        return "resume"
      case ScannerStatus.Starting:
        return "pause";
      case ScannerStatus.Idle:
        return "pause";
      case ScannerStatus.Ready:
        return "pause";
      case ScannerStatus.Scanning:
        return "pause";
      case ScannerStatus.Inspecting:
        return "pause";
      case ScannerStatus.Continuing:
        return "pause";
      case ScannerStatus.Deciding:
        return "resume";
      case ScannerStatus.Ejecting:
        return "resume";
      case ScannerStatus.Failed:
        return "resume";
      case ScannerStatus.Blocked:
      default:
        return "resume";
    }
  }
}
